/*
  Yas Cosmetics: previous / next arrows on the main product image.
  Works with Dawn's thumbnail gallery: each arrow selects the neighbouring thumbnail,
  so Dawn's own media switching, variant images and live-region announcements still apply.
*/
(() => {
  const script = document.currentScript;
  const labels = {
    prev: (script && script.dataset.prev) || 'Previous image',
    next: (script && script.dataset.next) || 'Next image',
  };
  const icon = (dir) =>
    `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="${
      dir === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7'
    }" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

  const visibleThumbs = (gallery) =>
    [...gallery.querySelectorAll('.thumbnail-list .thumbnail')].filter((b) => b.offsetParent !== null);

  const step = (gallery, delta) => {
    const thumbs = visibleThumbs(gallery);
    if (thumbs.length < 2) return;
    let i = thumbs.findIndex((b) => b.hasAttribute('aria-current'));
    if (i < 0) i = 0;
    const target = thumbs[(i + delta + thumbs.length) % thumbs.length];
    target.click();
    const list = target.closest('.thumbnail-list');
    if (list) {
      const item = target.closest('li') || target;
      const top = item.offsetTop - list.clientHeight / 2 + item.clientHeight / 2;
      list.scrollTo({ top, behavior: 'smooth' });
    }
  };

  const init = (gallery) => {
    if (gallery.dataset.yasArrows) return;
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer || gallery.querySelectorAll('.thumbnail-list .thumbnail').length < 2) return;
    gallery.dataset.yasArrows = 'true';
    ['prev', 'next'].forEach((dir) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `yas-gallery-arrow yas-gallery-arrow--${dir}`;
      button.setAttribute('aria-label', labels[dir]);
      button.innerHTML = icon(dir);
      button.addEventListener('click', () => step(gallery, dir === 'next' ? 1 : -1));
      viewer.appendChild(button);
    });
  };

  const run = () => document.querySelectorAll('media-gallery[data-desktop-layout*="thumbnail"]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  // Re-initialise when Dawn re-renders the product section (e.g. after a variant change).
  document.addEventListener('shopify:section:load', run);
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      run();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
